import React, { useEffect, useState } from "react";
import { useOrder } from "../context/OrderContext";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { usePrescriptionSave } from "../context/PrescriptionSaveContext";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";
import Modal from "../components/modals/Modal";
import { IconQuestionMark } from "@tabler/icons-react";

// TODO: Ne töröljük a vényt, ha szerkeszti szeretné és rákattint a "mégsem..." gombra

const VenyekLista = () => {
	const { order, updateOrder, createEmptyVeny } = useOrder();
	const { deletePrescription, loading: prescriptionLoading } = usePrescriptionSave();
	const navigate = useStepNavigate();
	const venyek = order.venyek || [];
	// Biztonságos aktivVenyIndex inicializálás
	const aktivVenyIndex = order.aktivVenyIndex !== undefined ? order.aktivVenyIndex : 0;

	const [deleteIdx, setDeleteIdx] = useState(null);
	const [showConfirmModal, setShowConfirmModal] = useState(false);
	const [showNewModal, setShowNewModal] = useState(false);
	const [editIdx, setEditIdx] = useState(null);

	useEffect(() => {
		const currentVenyek = order.venyek || [];

		if (!currentVenyek.length) {
			updateOrder((prev) => {
				return {
					...prev,
					venyek: [createEmptyVeny()],
					aktivVenyIndex: 0,
				};
			});
			navigate("/AdatVenyes");
		} else if (!currentVenyek[0] || !currentVenyek[0].veny_receipt) {
			navigate("/AdatVenyes");
		} else if (order.aktivVenyIndex === undefined) {
			updateOrder((prev) => ({
				...prev,
				aktivVenyIndex: 0,
			}));
		}
	}, [createEmptyVeny, navigate, order.aktivVenyIndex, order.venyek, updateOrder]);

	const handleAddVeny = () => {
		const base = venyek[aktivVenyIndex] || venyek[0] || {};
		const newVeny = createEmptyVeny();

		newVeny.veny_inscript_date = base.veny_inscript_date || new Date().toISOString().split('T')[0];
        newVeny.veny_nine_digit_id = base.veny_nine_digit_id || "";
        newVeny.veny_med_stamp_num = base.veny_med_stamp_num || "";
        newVeny.veny_med_name = base.veny_med_name || "";
        newVeny.veny_med_id = base.veny_med_id || null;

		updateOrder((prev) => ({
			...prev,
			venyek: [...prev.venyek, newVeny],
			aktivVenyIndex: prev.venyek.length,
		}));
		navigate("/AdatVenyes");
	};

	const handleEditVeny = (idx) => {
		setEditIdx(idx);
	};
	const handleConfirmEdit = () => {
		updateOrder((prev) => ({
			...prev,
			aktivVenyIndex: editIdx,
		}));
		setEditIdx(null);
		navigate("/AdatVenyes");
	};
	const handleCancelEdit = () => setEditIdx(null);

	const handleDeleteVeny = async (idx) => {
		setDeleteIdx(null);
		try {
			const result = await deletePrescription(idx);
			if (result.success) {
				setDeleteIdx(null);
			} else {
				console.error("Hiba a vény törlésekor:", result.error);
			}
		} catch (error) {
			console.error("Hiba a vény törlésekor:", error);
		}
	};

	const handleNext = () => setShowConfirmModal(true);
	const handleConfirmNext = () => {
		setShowConfirmModal(false);
		navigate("/OsszesitoTablazat");
	};
	const handleCancelNext = () => setShowConfirmModal(false);

	const handleShowNewModal = () => setShowNewModal(true);

	// const shoesMed =
    // order.venyek &&
    // order.venyek[order.aktivVenyIndex] &&
    // (order.venyek[order.aktivVenyIndex].shoes_med_left ||
    //  order.venyek[order.aktivVenyIndex].shoes_med_right);

	return (
		<TablerLayout title="Felvett vények listája">
			<div className="row justify-content-center">
				<div className="col-md-10 mb-4">
					<div className="card-body">
						<h5 className="mb-3">Felvett vények száma: {venyek.length}</h5>
						<h6 className="mb-3">Bal cipő típus: {order.hmeliorder.hmeliorder_shoes_med_left}, Jobb cipő típus: {order.hmeliorder.hmeliorder_shoes_med_right}</h6>
						{venyek.length === 0 ? (
							<div className="alert alert-warning">Még nem vett fel egy vényt sem.</div>
						) : (
							<ul className="list-group mb-3">
								{venyek.map((veny, idx) => (
									<li key={idx} className="list-group-item">
										<div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
											<div className="flex-grow-1 mb-2 mb-md-0">
												<b className="fs-5">#{idx + 1}</b> – <span className="text-primary fs-5">{veny.veny_receipt || "(nincs azonosító)"}</span>
												<div className="medium text-muted">
													{veny.veny_expirate_date && <>Lejár: {veny.veny_expirate_date} | </>}
													{veny.veny_inscript_date && <>Felírás: {veny.veny_inscript_date} | </>}
													{veny.veny_nine_digit_id && <>Kilencjegyű azonosító: {veny.veny_nine_digit_id} | </>}
													{veny.veny_med_name && <>Orvos: {veny.veny_med_name} | </>}
													{veny.veny_med_stamp_num && <>Pecsét: {veny.veny_med_stamp_num} | </>}
													{veny.veny_bno_code && <>BNO: {veny.veny_bno_code}</>}
												</div>
												<div className="small">
													{order.hmeliorder.hmeliorder_specaidtype && <>Támogatás: {order.hmeliorder.hmeliorder_specaidtype_national} | </>}
												
													{order.hmeliorder.hmeliorder_specaidtype === 2 && order.partner.partner_charitycare_num && <>Közgyógy ig. szám: {order.partner.partner_charitycare_num} | </>}
													{veny.veny_indvdl_permit_nr && <>Egyedi kérelem száma: {veny.veny_indvdl_permit_nr} | </>}
													{veny.veny_indstrl_accdnt && <>Üzemi baleset naplószám: {veny.veny_indstrl_accdnt} | </>}
													{order.venyek[order.aktivVenyIndex].shoes_med_left && <>Cipő orvosi kód (bal): {order.venyek[order.aktivVenyIndex].shoes_med_left} |</>}
													{order.venyek[order.aktivVenyIndex].shoes_med_right && <>Cipő orvosi kód (jobb): {order.venyek[order.aktivVenyIndex].shoes_med_right} |</>}
												</div>
												<div className="small">
													{veny.components && veny.components.length > 0 && (
														<span>
															Tartozékok:&nbsp;
															{veny.components.map((component, i) => (
																<span key={i} className="p-1">
																	{component.aidfinance_national} ({component.is_left === 1 ? "Bal" : "Jobb"});
																</span>
															))}
														</span>
													)}
												</div>
											</div>

											{/* Reszponzív gombok */}
											<div className="d-flex flex-row flex-md-column gap-2 mt-2 mt-md-0 button-wrapper w-100 w-md-auto">
												<button
													className="btn btn-sm btn-primary flex-fill button-half"
													onClick={() => handleEditVeny(idx)}
													disabled={prescriptionLoading}
												>
													Szerkesztés
												</button>
												{/* <button
													className="btn btn-sm btn-danger flex-fill button-half"
													onClick={() => setDeleteIdx(idx)}
													disabled={
														venyek.length <= 1 ||
														prescriptionLoading ||
														veny.shoes_med_left ||
														veny.shoes_med_right
													}
													title={
														venyek.length <= 1
															? "Legalább egy vénynek maradnia kell!"
															: veny.shoes_med_left || veny.shoes_med_right
															? "Nem törölhető, mert ehhez a vényhez cipő orvosi kód tartozik!"
															: ""
													}
												>
													Törlés
												</button> */}
											</div>
										</div>
									</li>
								))}
							</ul>
						)}
						<button className="btn btn-primary w-100 mb-3 fs-5" onClick={handleShowNewModal} disabled={prescriptionLoading}>
							+1 vény felvétele
						</button>
						<StepperNavButton side="right" label="Tovább" onClick={handleNext} disabled={venyek.length === 0} />
					</div>
				</div>
			</div>
			<Modal isOpen={editIdx !== null} onClose={handleCancelEdit} onConfirm={handleConfirmEdit} title="Vény szerkesztése" confirmText="Szerkesztés" cancelText="Mégsem" type="warning" confirmClass="btn btn-primary" cancelClass="btn btn-outline" icon={<IconQuestionMark size={70} stroke={2} className="text-warning" />}>
				<h4>Biztosan szerkeszteni szeretné ezt a vényt?</h4>
			</Modal>

			{deleteIdx !== null && (
				<Modal isOpen={deleteIdx !== null} onClose={() => setDeleteIdx(null)} onConfirm={() => handleDeleteVeny(deleteIdx)} title="Vény törlése" type="danger" confirmText="Törlés" cancelText="Mégsem" confirmClass="btn btn-danger" cancelClass="btn btn-outline" icon={<IconQuestionMark size={70} stroke={2} className="text-danger" />}>
					<h4>Biztosan törölni szeretné ezt a vényt?</h4>
				</Modal>
			)}
			<Modal isOpen={showConfirmModal} onClose={handleCancelNext} onConfirm={handleConfirmNext} title="Minden vényt felvett?" type="warning" confirmText="Igen, tovább" cancelText="Mégsem" confirmClass="btn btn-primary" cancelClass="btn btn-outline" icon={<IconQuestionMark size={70} stroke={2} className="text-warning" />}>
				<h4>Biztosan felvette az összes vényt?</h4>
			</Modal>
			<Modal isOpen={showNewModal} onClose={() => setShowNewModal(false)} onConfirm={handleAddVeny} title="Új vény felvétele" type="warning" confirmText="Igen" cancelText="Mégsem" confirmClass="btn btn-primary" cancelClass="btn btn-outline" icon={<IconQuestionMark size={70} stroke={2} className="text-warning" />}>
				<h4>Biztosan szeretne felvenni egy másik vényt?</h4>
			</Modal>
		</TablerLayout>
	);
};

export default VenyekLista;
